import { render } from "./pop-up-confirm-email.vue?vue&type=template&id=1a902337&scoped=true"
import script from "./pop-up-confirm-email.vue?vue&type=script&lang=js"
export * from "./pop-up-confirm-email.vue?vue&type=script&lang=js"

import "./pop-up-confirm-email.vue?vue&type=style&index=0&id=1a902337&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a902337"]])

export default __exports__